<template>
  <div>
    <p class="title">费用结算</p>
    <div v-if="step === 1">
      <!-- 收款信息 -->
      <orderReceipt @setIdList="getIdList"/>
      <!-- 付款信息 -->
      <orderPayment/>
    </div>
    <!-- 线下收款 -->
    <collection v-else :ids="ids" @back="back"/>
  </div>
</template>
<script>
import collection from './components/orderReceipt/components/collection/index.vue'
import orderReceipt from './components/orderReceipt/index.vue'
import orderPayment from './components/orderPayment/index.vue'

export default {
  data() {
    return {
      step: 1,
      ids: '',
    }
  },
  methods: {
    // 获取批量收款的值
    getIdList(val) {
      this.step = 2
      this.ids = val
    },
    // 线下收款提交审批成功
    back() {
      this.step = 1
    },
  },
  components: { collection, orderReceipt, orderPayment },
}
</script>
<style lang="scss" scoped>
.title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-weight: 600;
    font-size: 16px;
    color: #323233;
    margin-bottom: 14px;
  }
</style>
